<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h2>Artículos predefinidos</h2>
          <p>
            En este apartado se pueden gestionar los artículos predefinidos.
          </p>
          <b-row class="mb-3">
            <b-col :cols="12"> </b-col>
          </b-row>

          <b-row>
            <b-col :cols="12">
              <h3>Listado de artículos</h3>
              <v-server-table
                :url="table.url"
                ref="table"
                class="mt-4"
                :columns="table.columns"
                :options="table.options"
              >
                <div slot="afterFilterWrapper" class="form-group form-inline">
                  <b-button
                    class="ml-3"
                    variant="primary"
                    :to="{
                      name: 'AdminPredefinedProductsEditScreen',
                      params: { id: 'new' },
                    }"
                    >Nuevo producto predefinido</b-button
                  >

                  <b-button
                    variant="outline-danger"
                    class="ml-2"
                    :disabled="table.selected.length === 0"
                    @click="removeSelected()"
                    >Eliminar seleccionados</b-button
                  >
                </div>

                <div slot="h__checkbox">
                  <b-form-checkbox
                    v-model="table.allSelected"
                    @change="toggleAll"
                  />
                </div>

                <div slot="checkbox" slot-scope="props">
                  <b-form-checkbox
                    :checked="table.selected.includes(props.row.id)"
                    @change="toggleCell($event, props.row.id)"
                  />
                </div>

                <template v-slot:attributes="props">
                  {{ props.row.attributes.map((x) => x.name).join(', ') }}
                </template>

                <template v-slot:category="props">
                  {{ props.row.category ? props.row.category : '-' }}
                </template>

                <template v-slot:code_hex="props">
                  <span>#{{ props.row.code_hex }}</span>
                </template>

                <template v-slot:preview="props">
                  <img
                    style="max-height: 100px; max-width: 100px"
                    :src="props.row.image0"
                  />
                </template>

                <template v-slot:actions="props">
                  <b-button
                    :to="{
                      name: 'AdminPredefinedProductsEditScreen',
                      params: { id: props.row.id },
                    }"
                    size="sm"
                    variant="outline-primary"
                    class="mr-2"
                    >Editar</b-button
                  >

                  <b-button
                    @click="removeProduct(props.row.id)"
                    size="sm"
                    variant="outline-danger"
                    class="mr-2"
                    >Eliminar</b-button
                  >

                  <!-- <b-button
                    v-if="props.row.type === 'online'"
                    :to="{
                      name: 'AdminPredefinedProductsCustomizeScreen',
                      params: { id: props.row.id },
                    }"
                    size="sm"
                    class="mr-2"
                    :disabled="true"
                    >Personalizar</b-button
                  > -->
                </template>
              </v-server-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import store from '@/admin/store.js';

export default {
  name: 'AdminPredefinedProductsScreen',
  props: {},
  components: {},
  data() {
    return {
      table: {
        url: uris.predefinedProductsURI,
        selected: [],
        allSelected: false,
        columns: [
          'checkbox',
          'id',
          'reference_es',
          'reference_en',
          'slug_es',
          'slug_en',
          'category_info.reference',
          'preview',
          'actions',
        ],
        options: {
          sortable: ['reference'],
          headings: {
            reference_es: 'Nombre',
            reference_en: 'Nombre (EN)',
            slug_es: 'Slug',
            slug_en: 'Slug (EN)',
            preview: 'Vista previa imagen',
            'category_info.reference': 'Categoría',
            actions: 'Acciones',
          },
        },
      },
      sharedState: store.state,
    };
  },
  created() {},
  methods: {
    removeSelected() {
      this.table.selected.map((x) => {
        this.removeProduct(x);
      });
    },
    removeProduct(id) {
      if (
        confirm(
          '¿Estás seguro que deseas eliminar el producto predefinido con ID ' +
            id +
            '?'
        )
      ) {
        actions.deletePredefinedProduct(id).then((x) => {
          this.$refs.table.refresh();
        });
      }
    },
    toggleCell($event, id) {
      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      this.table.selected = checked
        ? this.$refs.table.data.map((row) => row.reference)
        : [];
    },
  },
  mounted() {},
};
</script>

<style scoped></style>
